import ExploreNFTsContainer from '../../containers/ExploreNFTs';

// import '../../assets/css/activity.css'
// import './activity.css'

const ExploreNFTs = () => {

  return <ExploreNFTsContainer />
}

export default ExploreNFTs;